import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { BrowserAndTabletView, MobileView } from 'components/DeviceDetect'
import CustomSlider from 'components/Slider'
import { SliderWrapper } from 'components/Widgets/Home/Slider/Slider.style'

const SlideItemSkeleton = ({ isMobile = false }) => (
  <div
    className={`relative ${
      isMobile ? 'h-[240px]' : 'h-[360px]'
    } rounded-xl overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200 mx-2`}
  >
    {/* Main background skeleton with gradient effect */}
    <div className="absolute inset-0">
      <Skeleton
        height="100%"
        baseColor="#f1f5f9"
        highlightColor="#e2e8f0"
        className="!rounded-xl"
      />
    </div>

    {/* Content overlay area */}
    <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8">
      {/* Title skeleton */}
      <div className="mb-3">
        <Skeleton
          width={isMobile ? 180 : 280}
          height={isMobile ? 20 : 28}
          baseColor="#e2e8f0"
          highlightColor="#f8fafc"
          className="mb-2"
        />
        <Skeleton
          width={isMobile ? 120 : 200}
          height={isMobile ? 16 : 20}
          baseColor="#e2e8f0"
          highlightColor="#f8fafc"
        />
      </div>

      {/* Button skeleton */}
      <div className="flex justify-start">
        <Skeleton
          width={isMobile ? 100 : 140}
          height={isMobile ? 32 : 40}
          baseColor="#e2e8f0"
          highlightColor="#f8fafc"
          className="!rounded-lg"
        />
      </div>
    </div>

    {/* Product image placeholder (right side) */}
    <div
      className={`absolute ${
        isMobile ? 'right-4 top-6 w-20 h-20' : 'right-12 top-12 w-28 h-28'
      }`}
    >
      <Skeleton
        height="100%"
        width="100%"
        baseColor="#cbd5e1"
        highlightColor="#e2e8f0"
        className="!rounded-lg"
      />
    </div>
  </div>
)

const SliderSkeleton = () => {
  return (
    <SliderWrapper>
      <BrowserAndTabletView>
        <CustomSlider
          style={{ marginTop: '0' }}
          settings={{
            infinite: false,
            autoplay: false,
            dots: true,
            arrows: true,
          }}
        >
          {Array(3)
            .fill()
            .map((_, index) => (
              <SlideItemSkeleton key={index} />
            ))}
        </CustomSlider>
      </BrowserAndTabletView>

      <MobileView>
        <CustomSlider
          style={{ marginTop: '0' }}
          settings={{
            infinite: false,
            autoplay: false,
            dots: true,
            arrows: false,
          }}
        >
          {Array(3)
            .fill()
            .map((_, index) => (
              <SlideItemSkeleton key={index} isMobile />
            ))}
        </CustomSlider>
      </MobileView>
    </SliderWrapper>
  )
}

export default SliderSkeleton
